module.exports = __webpack_public_path__ + "static/media/item_40_3.20be2040.png";